const PROJECT_TASK_TEMPLATE_TYPES = {
  General: 'General',
  Client: 'Client'
}

const EMC_MODELS = {
  G4: 'G4',
  G5: 'G5'
}

const EMC_PITCHES = {
  P15: '15mm',
  P9: '9mm',
  P6: '6mm',
  P4: '4mm'
}

const EMC_BOARD_MATRIX_MULTIPLIERS = []
EMC_BOARD_MATRIX_MULTIPLIERS['4mm'] = 64
EMC_BOARD_MATRIX_MULTIPLIERS['6mm'] = 48
EMC_BOARD_MATRIX_MULTIPLIERS['9mm'] = 32
EMC_BOARD_MATRIX_MULTIPLIERS['15mm'] = 20

const EMC_FACES = {
  SF: 'Single Face',
  DF: 'Double Face',
  DSF: 'Dual Single Face'
}

const CABINET_FACES = {
  SF: 'Single Face',
  DF: 'Double Face'
}

const CABINET_STYLES = {
  XPS: {
    label: 'XPS Cabinet',
    value: 'XPS'
  },
  FULL: {
    label: 'Full Depth Cabinet',
    value: 'FULL'
  },
  CUSTOM_SHAPE: {
    label: 'Custom Shape',
    value: 'CUSTOM_SHAPE'
  }
}

const CABINET_FACE_TYPES = {
  Polycarbonate: {
    label: 'Polycarbonate',
    value: 'Polycarbonate',
    multiplier: 1
  },
  VFormedPoly: {
    label: 'VFormed Poly',
    value: 'VFormed Poly',
    multiplier: 1.2
  },
  Routed: {
    label: 'Routed',
    value: 'Routed',
    multiplier: 1.25
  },
  RoutedPushThru: {
    label: 'Routed Push-Thru',
    value: 'Routed Push-Thru',
    multiplier: 1.35
  }
}

// Standard paint colors for edge quote (with hex for swatch). Value 'Custom' adds cost; others do not.
const STANDARD_PAINT_COLORS = [
  { value: 'TBD', label: 'T.B.D.', hex: null },
  { value: 'Black', label: 'Black (S1730058)', hex: '#1a1a1a' },
  { value: 'Orange', label: 'Orange (RAL 2004, PMS 166)', hex: '#ed760e' },
  { value: 'Blue', label: 'Blue (RAL 5002, PMS 288)', hex: '#2e3a6b' },
  { value: 'White', label: 'White (RAL 9003)', hex: '#f4f4f4' },
  { value: 'Red Orange', label: 'Red Orange (RAL 2001, PMS 7580)', hex: '#b8522a' },
  { value: 'Dark Blue', label: 'Dark Blue (RAL 5013, PMS 282)', hex: '#1e2460' },
  { value: 'Gray Blue', label: 'Gray Blue (RAL 7031, PMS 431)', hex: '#5d6b7a' },
  { value: 'Red', label: 'Red (RAL 3020, PMS 7620)', hex: '#a72926' },
  { value: 'Light Blue', label: 'Light Blue (RAL 5024, PMS 7454)', hex: '#467381' },
  { value: 'Dark Gray', label: 'Dark Gray (RAL 7016, PMS 7540)', hex: '#383e42' },
  { value: 'Dark Red', label: 'Dark Red (RAL 3000, PMS 7621)', hex: '#6d3428' },
  { value: 'Green', label: 'Green (RAL 6002, PMS 2427)', hex: '#2d5016' },
  { value: 'Brown', label: 'Brown (RAL 8011, PMS 4625)', hex: '#5c3317' },
  { value: 'Maroon', label: 'Maroon (RAL 3004, PMS 188)', hex: '#752b2b' },
  { value: 'Moss Green', label: 'Moss Green (RAL 6005, PMS 350)', hex: '#0f4c2d' },
  { value: 'Light Ivory', label: 'Light Ivory (RAL 1015, PMS 7506)', hex: '#e6d4a8' },
  { value: 'Purple', label: 'Purple (RAL 4005, PMS 2081)', hex: '#6c4675' },
  { value: 'Light Green Blue', label: 'Light Green Blue (RAL 6032, PMS 348)', hex: '#27867e' },
  { value: 'Yellow', label: 'Yellow (RAL 1021, PMS 7406)', hex: '#f5c000' },
  { value: 'Signal Yellow', label: 'Signal Yellow (RAL 1003, PMS 7409)', hex: '#f7a600' },
  { value: 'Purple Violet', label: 'Purple Violet (RAL 4007, PMS 518)', hex: '#3d2850' },
  { value: 'Signal Violet', label: 'Signal Violet (RAL 4008, PMS 512)', hex: '#924e7d' },
  { value: 'Light Green', label: 'Light Green (RAL 6018, PMS 7738)', hex: '#7cb342' },
  { value: 'Custom', label: 'Custom Color', hex: null }
]

const MONUMENT_STYLES = {
  DuraCore: 'DuraCore Monument',
  Masonry: 'Masonry Monument'
}

const PEDESTAL_STYLES = {
  Pedestal: 'Pedestal',
  PoleCover: 'Pole Cover',
  PedestalSkins: 'Pedestal Skins'
}

const QUOTE_TYPES = {
  Edge: 'EDGE',
  Adhoc: 'AD-HOC'
}

const QUOTE_ADDITIONAL_ITEM_CATEGORIES = {
  EMC: 'EMC',
  Fabrication: 'Fabrication',
  ExistingSignRemoval: 'Existing Sign Removal',
  Installation: 'Installation',
  SiteSurvey: 'Site Survey',
  Shipping: 'Shipping',
  CustomColor: 'Custom Color',
  Overage: 'Overage',
  Discount: 'Discount',
  Tax: 'Tax'
}

const QUOTE_PAYMENT_TERMS_OPTIONS = {
  Standard: 'Standard Payment Terms',
  POOnly: 'P.O. Only + Net 30',
  ClientInstall: 'Client Install - Pay Prior to Shipping'
}

const PROJECT_INSTALLATION_TYPE = {
  Grs: 'GRS',
  Client: 'Client'
}

const PROJECT_STAGES = {
  Staging: 'Staging',
  PreProduction: 'Pre-Production',
  Production: 'Production',
  Shipping: 'Shipping',
  Install: 'Install',
  PostInstall: 'Post Install',
  Invoicing: 'Invoicing',
  MarginReview: 'Margin Review',
  Complete: 'Complete',
  Cancelled: 'Cancelled',
  OnHold: 'On Hold'
}

const PROJECT_BALANCE_TERMS = {
  NotYetDetermined: 'Not Yet Determined',
  Shipping25Prior: '25% prior to shipping',
  Shipping100Prior: '100% prior to shipping',
  DueAfterInstall: 'Due after install'
}

const PROJECT_CLIENT_VOLTAGE = {
  NotRequired: 'Not Required',
  NotYetDetermined: 'Not Yet Determined',
  V120: '120v',
  V240: '240v',
  MultiSite: 'Multi-Site, See Sheet'
}

const PROJECT_FLIGHT_CHECK = {
  NotYetScheduled: 'Not Yet Scheduled',
  Scheduled: 'Scheduled',
  Completed: 'Completed'
}

const PROJECT_PERMIT = {
  NotYetDetermined: 'Not Yet Determined',
  WaitingOnJobPacket: 'Waiting on Job Packet',
  Investigating: 'Investigating',
  AcquiringDocuments: 'Acquiring Documents',
  ContractingInstaller: 'Contracting Installer',
  InstallerPullingPermit: 'Installer Pulling Permit',
  NotNeeded: 'Not Needed',
  Submitted: 'Submitted',
  Approved: 'Approved',
  ClientInstall: 'Client Install - Not in GRS Scope',
  ClientSubmitting: 'Client Submitting',
  VarianceProcess: 'Variance Process'
}

const PROJECT_ARTWORK = {
  NotYetDetermined: 'Not Yet Determined',
  NotNeeded: 'Not Needed',
  Approved: 'Approved'
}

const PROJECT_FABREND = {
  Incomplete: 'Incomplete',
  InProgress: 'In Progress',
  PendingReview: 'Pending Review',
  PendingRFI: 'Pending RFI',
  Completed: 'Completed',
  NotNeeded: 'Not Needed'
}

const PROJECT_DEPOSIT_STATUS = {
  NotReceived: 'Not Received',
  POReceived: 'PO Received',
  PaymentReceived: 'Payment Received',
  POAndPaymentReceived: 'PO & Payment Received'
}

const PROJECT_CRATING_STATUS = {
  Pending: 'Pending',
  Complete: 'Complete'
}

const PROJECT_ACCOUNTING_APPROVAL = {
  Pending: 'Pending',
  Approved: 'Approved'
}

const PROJECT_COIW9 = {
  Received: 'Received',
  NotReceived: 'Not Received'
}

const PROJECT_POST_INSTALL_CALL = {
  Incomplete: 'Incomplete',
  Completed: 'Completed',
  Scheduled: 'Scheduled'
}

const PROJECT_INVOICE_STATUS = {
  InvoiceSent: 'Invoice Sent',
  Incomplete: 'Incomplete'
}

const PROJECT_PRODUCTION_PO_CATEGORIES = {
  EMC: 'EMC',
  Fabrication: 'Fabrication',
  Monument: 'Monument',
  Steel: 'Steel'
}

const PROJECT_SHIPPING_PO_CATEGORIES = {
  EMC: 'EMC',
  Fabrication: 'Fabrication',
  Steel: 'Steel/Brackets',
  Monument: 'Monument',
  CombinedEMCFab: 'Combined EMC/Fab'
}

const PROJECT_INSTALLER_PO_CATEGORIES = {
  Installation: 'Installation',
  Permit: 'Permit',
  Variance: 'Variance',
  Manual: 'Manual'
}

const PROJECT_INVOICING_ACQUIRED_ACTIONS = {
  PowerOn: 'Power On',
  SignOnline: 'Sign Online',
  NotApplicable: 'Not Applicable'
}

const PROJECT_INVOICING_CUSTOMER_DISPOSITION = {
  Displeased: 'Customer Displeased',
  Okay: 'Customer Okay',
  Happy: 'Customer Happy'
}

const COMMISSION_TYPES = {
  Project: 'Project',
  ChangeOrder: 'Change Order'
}

const PAYOUT_FILTER_STATUSES = {
  All: 'All',
  Pending: 'Pending',
  Qualified: 'Qualified',
  Paid: 'Paid',
  Cancelled: 'Cancelled',
  OnHold: 'On Hold'
}

const APP_CONFIG_FIELDS = {
  CommissionDiscountPercentage: 'commissionDiscountPercentage',
  DesignerEmail: 'designerEmail',
  zohoRefreshToken: 'zohoRefreshToken',
  DisplayPricingMarkup: 'displayPricingMarkup',
  DisplayPricingPPMs: 'displayPricingPerMeter',
  DisplayPricingDiscounts: 'displayPricingDiscounts',
  DisplayPricingPowers: 'displayPricingPowers',
  EmcModelVisibility: 'emcModelVisibility',
  SurveyEmails: 'surveyEmails'
}

const METRICS_TABS = {
  Entire: 'Entire',
  Staging: 'Staging',
  PreProduction: 'Pre-Production',
  Production: 'Production',
  Installation: 'Installation',
  Accounting: 'Accounting'
}

const ARTWORK_REQUEST_STATUSES = {
  NotYetStarted: 'Not Yet Started',
  Processing: 'Processing',
  ReadyForReview: 'Ready For Review',
  PendingRevision: 'Pending Revision',
  Completed: 'Completed'
}

const ARTWORK_REQUEST_PRIORITIES = {
  P1: 'P1',
  P2: 'P2',
  P3: 'P3'
}

const PAYOUT_REPORT_TYPES = {
  ProjectCommission: 'Commission For Projects',
  ProjectOverage: 'Overage For Projects',
  ChangeOrderCommission: 'Commission For Change Orders'
}

const ZOHO_OPPORTUNITIES_SEARCH_TYPE = {
  All: 'all',
  Latest: 'latest'
}

const CUSTOMER_PROVIDING_DEPOSIT = {
  Yes: 'Yes',
  No: 'No',
  Unknown: 'Unknown'
}

module.exports = {
  PROJECT_TASK_TEMPLATE_TYPES,
  EMC_MODELS,
  EMC_PITCHES,
  EMC_BOARD_MATRIX_MULTIPLIERS,
  EMC_FACES,
  CABINET_FACES,
  CABINET_STYLES,
  CABINET_FACE_TYPES,
  STANDARD_PAINT_COLORS,
  MONUMENT_STYLES,
  PEDESTAL_STYLES,
  QUOTE_TYPES,
  QUOTE_ADDITIONAL_ITEM_CATEGORIES,
  QUOTE_PAYMENT_TERMS_OPTIONS,
  PROJECT_INSTALLATION_TYPE,
  PROJECT_STAGES,
  PROJECT_BALANCE_TERMS,
  PROJECT_CLIENT_VOLTAGE,
  PROJECT_FLIGHT_CHECK,
  PROJECT_PERMIT,
  PROJECT_ARTWORK,
  PROJECT_FABREND,
  PROJECT_DEPOSIT_STATUS,
  PROJECT_CRATING_STATUS,
  PROJECT_ACCOUNTING_APPROVAL,
  PROJECT_COIW9,
  PROJECT_POST_INSTALL_CALL,
  PROJECT_INVOICE_STATUS,
  PROJECT_PRODUCTION_PO_CATEGORIES,
  PROJECT_SHIPPING_PO_CATEGORIES,
  PROJECT_INSTALLER_PO_CATEGORIES,
  PROJECT_INVOICING_ACQUIRED_ACTIONS,
  PROJECT_INVOICING_CUSTOMER_DISPOSITION,
  COMMISSION_TYPES,
  PAYOUT_FILTER_STATUSES,
  APP_CONFIG_FIELDS,
  METRICS_TABS,
  ARTWORK_REQUEST_STATUSES,
  ARTWORK_REQUEST_PRIORITIES,
  PAYOUT_REPORT_TYPES,
  ZOHO_OPPORTUNITIES_SEARCH_TYPE,
  CUSTOMER_PROVIDING_DEPOSIT
}
